import { render, staticRenderFns } from "./sup-coupon.vue?vue&type=template&id=c1029f20"
import script from "./sup-coupon.vue?vue&type=script&lang=js"
export * from "./sup-coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports